/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalSummaryViewModel } from './ProposalSummaryViewModel';
import {
    ProposalSummaryViewModelFromJSON,
    ProposalSummaryViewModelFromJSONTyped,
    ProposalSummaryViewModelToJSON,
} from './ProposalSummaryViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfProposalSummaryViewModel
 */
export interface ResultOfProposalSummaryViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfProposalSummaryViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalSummaryViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalSummaryViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalSummaryViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalSummaryViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfProposalSummaryViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfProposalSummaryViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ProposalSummaryViewModel}
     * @memberof ResultOfProposalSummaryViewModel
     */
    data?: ProposalSummaryViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalSummaryViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfProposalSummaryViewModel interface.
 */
export function instanceOfResultOfProposalSummaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfProposalSummaryViewModelFromJSON(json: any): ResultOfProposalSummaryViewModel {
    return ResultOfProposalSummaryViewModelFromJSONTyped(json, false);
}

export function ResultOfProposalSummaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfProposalSummaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ProposalSummaryViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfProposalSummaryViewModelToJSON(value?: ResultOfProposalSummaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ProposalSummaryViewModelToJSON(value.data),
        'Count': value.count,
    };
}

